import { createFileRoute } from '@tanstack/react-router'

import { SubscriptionV2StepPage } from '../../../../components/pages/subscription-v2/subscription-v2-step-page.tsx'

export const Route = createFileRoute('/subscribe/$subscriptionId/$stepId')({
  component: function Component() {
    const { subscriptionId, stepId } = Route.useParams()

    // `SubscriptionV2StepPage` stores the local changes for a given step
    // We want to reset that state when the step changes
    return <SubscriptionV2StepPage key={`${subscriptionId}/${stepId}`} />
  },
})
